<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import Url from '@/views/analyse/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'
import Qs from 'qs'
import axios from '@/utils/request'
import base from '@/api/base'
import URL from '@/views/mis/util/url'

let acted = { '1': '激活', '0': '未激活' }

//交易账户状态
const accountStatusList = {
  'A': '已激活',
  'S': '冻结',
  'D': '销户',
  'T': '测试',
  'BL': '黑名单',
  'N': '未激活'
}

function getToday() {
  return formatDate(new Date())
}

function getTomorrow() {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return formatDate(tomorrow)
}

function formatDate(date) {
  let year = date.getFullYear()
  let month = (date.getMonth() + 1).toString().padStart(2, '0') // 月份是从0开始的，所以要加1并确保是两位数
  let day = date.getDate().toString().padStart(2, '0')
  let time = year + '/' + month + '/' + day
  console.info(time)
  return time
}

function getTimestr() {
  return [getToday(), getTomorrow()]
}

export default {
  name: 'loginInfoList',
  components: {
    FORM,
    tablePage
  },

  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '账号', field: 'customerNumber' },
          {
            title: '开户时间',
            field: 'regTime',
            type: 6,
            data: getTimestr(),
            format: 'yyyy/MM/dd',
            startEndParam: ['regStartTime', 'regEndTime']
          },
          {
            title: '登陸時間',
            field: 'loginTime',
            type: 6,
            data: getTimestr(),
            format: 'yyyy/MM/dd',
            startEndParam: ['loginStartTime', 'loginEndTime']
          },
          { title: '激活狀態', field: 'acted', type: 2, optionList: acted },
          { title: '交易账户状态', field: 'accountStatusCode', type: 2, optionList: accountStatusList},
          { click: window.$t('common.search') },
          { click: window.$t('common.export'), auth: 'analyse:loginInfo:export' },
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.sleeping.loginInfoList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { field: 'customerNumber', title: '会员账号' },
          { field: 'name', title: '姓名' },
          { field: 'email', title: '邮箱' },
          { field: 'regTime', title: '注册时间' },
          { field: 'activeDate', title: '激活时间' },
          { field: 'accountGroup', title: '账户组别' },
          { field: 'paymentGatewayTags', title: '支付网关标记' },
          { field: 'payVerificationMark', title: '支付验证标记' },
          { field: 'accountLevelCode', title: '用戶类型' },
          { field: 'accountStatusCode', title: '交易账户状态' },
          { field: 'utm', title: '媒介' },
          { field: 'remark', title: '后台客户维护标记' },
          { field: 'recentLoginTime', title: '最近登录时间' },
          { field: 'utime', title: '更新時間' },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: '同步',
                click: 'synData',
                type: 'primary',
                icon: 'el-icon-editRebate',
                auth: 'analyse:login:syn'
              }
            ]
          }
        ]
      },
      totalNum: {}
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    bthClick(clickName, row) {
      if (clickName == 'synData') {
        this.synData(row)
      }
    },synData: function(row) {
      console.info(row)
      this.dataChange(Url.sleeping.loginInfoSynCustomers, row, res => {
        this.$message.success(res.message)
      })
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.formatDate(data)
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('导出' == clickName || window.$t('common.export') == clickName) {
        this.formatDate(data)
        download.exportExcel(Url.sleeping.loginInfoDown, data, 'A客户交易时间长度分类')
      }
    },

    formatDate(data) {
      data.regStartTime = data.regStartTime ? new Date(data.regStartTime).getTime() : ''
      data.regEndTime = data.regEndTime ? new Date(data.regEndTime).getTime() : ''
      data.loginStartTime = data.loginStartTime ? new Date(data.loginStartTime).getTime() : ''
      data.loginEndTime = data.loginEndTime ? new Date(data.loginEndTime).getTime() : ''
    }
  },
  mounted() {

  }

}
</script>

